import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Input, InputStyle } from 'module/ui/components/atoms/input/input';
import { Height, InputFocus } from 'module/ui/components/atoms/input/input';
import { InputNumber } from 'module/ui/components/atoms/input/input-number';
import { InputDuration } from 'module/ui/components/atoms/input-duration/input';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { Select as AntSelect } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';

export const Select = styled(AntSelect).attrs<{
  width?: number;
  suffixIcon?: ReactNode;
}>(({ width, suffixIcon }) => ({
  bordered: false,
  placeholder: 'Select...',
  style: { minWidth: width ?? 160 },
  autoFocus: true,
  suffixIcon: suffixIcon ?? <FontAwesomeIcon icon={faChevronDown} />,
  dropdownMatchSelectWidth: false,
  dropdownStyle: {
    minWidth: '300px',
  },
}))`
  ${InputStyle};
  .ant-select-selector {
    ${Height};
    display: flex;
    align-items: center;
  }
  .ant-select-arrow {
    top: 48%;
    width: 16px;
    height: 16px;
    color: var(--icon-secondary);
  }
  &.ant-select-open {
    ${InputFocus};
  }
`; // as StyledComponent<typeof AntSelect, DefaultTheme, { width?: number }, never>;

export const Text = styled.div`
  min-width: 80px;
  text-align: right;
`;

/** TODO: Move out to custom select component */
export const Fields = styled(Select)`
  background: var(--coolest-gray-20);
  padding-left: var(--spacing-03);
  ${InputStyle};
  padding-left: 0;
  &.ant-select-open,
  &:focus-within {
    ${InputFocus};
  }
  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    right: var(--spacing-05);
    .ant-select-selection-search-input {
      ${Height};
      padding-right: var(--spacing-02);
    }
  }
  /* Keep custom option content (e.g. Tag) vertically centered in the selected value */
  .ant-select-selector {
    .ant-select-selection-item {
      display: flex;
      align-items: center;
    }
  }
  padding-left: var(--spacing-05);
  &:hover {
    cursor: pointer !important;
  }
`;
export const StyledFieldsOption = styled(Select.Option)``;

export const NumericInput = styled(InputNumber).attrs({
  placeholder: 'Enter value',
  autoFocus: true,
})`
  min-width: 240px;
  max-width: 240px;
`;

export const DurationInput = styled(InputDuration)`
  min-width: 240px;
  max-width: 240px;
`;

export const TextInput = styled(Input).attrs({
  type: 'text',
  placeholder: 'Enter value',
  autoFocus: true,
})`
  padding-left: var(--spacing-05);
  ::placeholder {
    padding-left: var(--spacing-01);
  }
  min-width: 240px;
  max-width: 240px;
`;
